// ----------------------------------------------------------------------
// <copyright file="Izenda.MapStaticContentStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Other Settings Store
 */
!(function() {
  var MAX_CACHE_BACKGROUND_ITEMS = 3;
  var ReportPartMapConstants = require('logic/data/Izenda.ReportPartMapConstants');
  var MappingKey = ReportPartMapConstants.MappingKey;
  var fetcher = require('fetchers/Izenda.MapStaticContentFetcher');
  const {find, get, invoke, compact, groupBy, deburr, memoize} = require('lodash/fp');

  function createMappingData(values, mappingValues, mappingKeys) {
    var groupName;

    var matchedPoints = groupBy(function(mapVal) {
      groupName = find(function(val) {
        return isMatchedPoint(val, mapVal, mappingKeys);
      }, values);

      return groupName;
    }, mappingValues);

    return matchedPoints;

    function isMatchedPoint(pointVal, source, mappingKeys) {
      return !!find(function(mappingField) {
        return String.compareString(deburr(source[mappingField]), deburr(pointVal));
      }, mappingKeys);
    }
  }

  module.exports = {
    /**
     * Get GEO file based on map name, map name is defined in MapCollectionConstants
     * @param  {string} mapName
     * @return {json}
     */
    getGEOJson: memoize(function(mapName) {
      // check - clear cache if more than 3 items are cached
      var cache = get('cache', this.getGEOJson);
      cache.size > MAX_CACHE_BACKGROUND_ITEMS && invoke('clear', cache);

      return fetcher.getGEOJson(mapName);
    }),

    /**
     * Get details of cities by state
     * @param  {array} values
     * @param  {array} mappingValues
     * @return {any} the point to draw on the map
     */
    getCitiesByState: function(values, mappingValues) {
      var mappingData = createMappingData(compact(values), mappingValues, MappingKey.state);
      return Promise.resolve(mappingData);
    },

    /**
     * Get details of cities
     * @param  {array} criterias
     * @param  {array} values
     * @return {array}
     */
    getCities: function(values, mappingValues) {
      var mappingData = createMappingData(compact(values), mappingValues, MappingKey.city);
      return Promise.resolve(mappingData);
    },

    /**
     * Get details of postal code
     * @param  {array} criterias
     * @param  {array} values
     * @return {array}
     */
    getPostalCode: function(values, mappingValues) {
      var mappingData = createMappingData(compact(values), mappingValues, MappingKey.postalCode);
      return Promise.resolve(mappingData);
    },

    /**
     * Get list of country codes
     * @return {array}
     */
    getCountryCode: () => {
      return fetcher.getCountryCode();
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/logic/Izenda.MapStaticContentStore.js